import { Button } from '@material-ui/core'
import React, { useState, useRef, useEffect, useContext } from 'react'
import './ProductCard.css'
import { currencyFormat } from '@/custom/common/components'
import BuynowContext from '@/product/context/buynow/buynowContext'
import { mapData } from '@/product/common/components'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import debounce from 'lodash.debounce'
import { getImagepath } from '@/custom/common/components'
import {
    dateFormatFunction,
    timeFormatFunction,
    hoursMinutesFormateFunction,
} from '@/custom/common/components'

const CartItem = (props) => {
    const [product, setProduct] = useState()
    const [reload, setReload] = useState(false)
    const { addToCart } = useContext(BuynowContext)

    useEffect(() => {
        setProduct(props.data)
    }, [props.data])

    const validationArray = Yup.object({
        quantity: Yup.number()
            .min(1, `${'min quantity'} `)
            .max(
                product ? product.projects_qty - product.projects_sold : 0,
                `${'max quantity'} ${product ? product.projects_qty - product.projects_sold : 0}`,
            )
            .required('Enter quantity'),
    })

    const formik = useFormik({
        initialValues: {
            quantity: 0,
        },
        validationSchema: validationArray,
        onSubmit: debounce((values) => {
            addToCart({
                cart: [
                    {
                        product_id: product.project_id,
                        qty: values.quantity,
                    },
                ],
            })
        }, 1000),
    })

    useEffect(() => {
        if (product) {
            formik.values.quantity = product ? product.qty : 0
            setReload(!reload)
        }
    }, [product])

    useEffect(() => {
        if (product) {
            if (formik.values.quantity !== product.qty) {
                formik.submitForm()
            }
        }
    }, [formik.values.quantity])

    const formikQuantity = [
        {
            label: '',
            name: 'quantity',
            type: 'number',
            placeholder: 'Qty',
            size: 'small',
            autoFocus: false,
            formik: formik,
        },
    ]

    return (
        <>
            {product ? (
                <>
                    <div className="cartItem d-flex justify-content-between align-items-start">
                        <div className="itemInfo d-flex justify-content-start">
                            <div className="pclImg">
                                {/* <img
                                    src={getImagepath(product.projects_avatar)}
                                    alt={product.title}
                                /> */}

                                <img
                                    src={getImagepath(product.projects_avatar)}
                                    alt={product.title}
                                    onError={(e) => {
                                        e.target.onerror = null // prevent infinite loop
                                        e.target.src = `/assets/images/profile_picture.png`
                                    }}
                                />
                            </div>
                            <div className="listContent">
                                <h2 className="listProdTitle">{product.projects_title}</h2>
                                <div className="itemDetailsRoot">
                                    {props.from == 'buynowcart' ||
                                    props.from == 'buynowcheckout' ||
                                    props.from == 'offercheckout' ||
                                    (props.from == 'invoice' &&
                                        product.buynow_autype === 'buynow') ? (
                                        <>
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>{'Amount'}:</span>
                                                    <span>{currencyFormat(product.amount)}</span>
                                                </h5>
                                                {/* <h5>
                                                    <span>{'Charity Name'}:</span>{' '}
                                                    <span>{product.custom_projects_charity_name}</span>
                                                </h5> */}
                                            </div>
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>{'Winning Offer Amount'}:</span>
                                                    <span>{currencyFormat(product.per_total)}</span>
                                                </h5>
                                                {/* {props.from == 'invoice' &&
                                                product.buynow_autype === 'buynow' ? (
                                                    <h5>
                                                        <span>Delivery Status:</span>
                                                        <span>
                                                            {product.delivered === 1
                                                                ? 'In Transit'
                                                                : product.delivered === 2
                                                                ? 'Ready for Pickup'
                                                                : product.delivered === 3
                                                                ? 'Completed'
                                                                : product.delivered === 4
                                                                ? 'Cancelled'
                                                                : 'Pending'}
                                                        </span>
                                                    </h5>
                                                ) : null} */}
                                            </div>
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>
                                                        {'Time to Give Network Fee'}:
                                                        {/* {'Service Charges'} ({product.tax_percent}%): */}
                                                    </span>
                                                    <span>{currencyFormat(product.total_tax)}</span>
                                                </h5>
                                            </div>
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>{'Total'}:</span>
                                                    <span>
                                                        {currencyFormat(product.total_amount)}
                                                    </span>
                                                </h5>
                                            </div>
                                        </>
                                    ) : props.from == 'makeoffercart' ? (
                                        <>
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>Quantity Requested:</span>
                                                    <span>{product.qty}</span>
                                                </h5>
                                            </div>
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>Amount Offered:</span>
                                                    <span>{currencyFormat(product.amount)}</span>
                                                </h5>
                                            </div>
                                        </>
                                    ) : props.from == 'cart' ||
                                      props.from == 'checkout' ||
                                      (props.from == 'invoice' &&
                                          product.buynow_autype === 'live') ? (
                                        <>
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>{'Winning Offer Amount'}:</span>
                                                    <span>{currencyFormat(product.per_total)}</span>
                                                </h5>

                                                {/* {props.from == 'invoice' &&
                                                product.buynow_autype === 'live' ? (
                                                    <h5>
                                                        <span style={{ display: 'inline' }}>
                                                            Delivery Status:
                                                        </span>
                                                        <span>
                                                            {product.delivered === 1
                                                                ? 'In Transit'
                                                                : product.delivered === 2
                                                                ? 'Ready for Pickup'
                                                                : product.delivered === 3
                                                                ? 'Completed'
                                                                : product.delivered === 4
                                                                ? 'Cancelled'
                                                                : 'Pending'}
                                                        </span>
                                                    </h5>
                                                ) : null} */}
                                            </div>
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>
                                                        {'Time to Give Network Fee'}:
                                                        {/* {'Service Charges'}({product.tax_percent}%): */}
                                                    </span>
                                                    <span>{currencyFormat(product.total_tax)}</span>
                                                </h5>
                                            </div>
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>{'Total'}:</span>
                                                    <span>
                                                        {currencyFormat(product.total_amount)}
                                                    </span>
                                                </h5>
                                            </div>
                                        </>
                                    ) : null}
                                    {product.custom_projects_charity_name && (
                                        <div className="listLotInfo d-flex justify-content-start align-items-center ">
                                            <h5>
                                                <span>{'Charity Name'}:</span>{' '}
                                                <span>{product.custom_projects_charity_name}</span>
                                            </h5>
                                        </div>
                                    )}
                                    {product.custom_projects_meeting_venue && (
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>{'Meeting venue'}:</span>{' '}
                                                <span>{product.custom_projects_meeting_venue}</span>
                                            </h5>
                                        </div>
                                    )}
                                    {product.custom_projects_meeting_datetime && (
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>{'Date'}:</span>{' '}
                                                <span>
                                                    {dateFormatFunction(
                                                        product.custom_projects_meeting_datetime,
                                                    )}
                                                </span>
                                            </h5>
                                        </div>
                                    )}
                                    {product.custom_projects_meeting_datetime && (
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>{'Time'}:</span>{' '}
                                                <span>
                                                    {' '}
                                                    {timeFormatFunction(
                                                        product.custom_projects_meeting_datetime,
                                                        'hh:mm A',
                                                    )}
                                                </span>
                                            </h5>
                                        </div>
                                    )}
                                    {product.custom_projects_meeting_duration > 0 && (
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>{'Duration'}:</span>{' '}
                                                <span>
                                                    {' '}
                                                    {hoursMinutesFormateFunction(
                                                        product.custom_projects_meeting_duration,
                                                    )}
                                                </span>
                                            </h5>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* <div className="itemInfo">
                            <h5>
                                <span>{'Charity Name'}:</span>{' '}
                                <span>{product.custom_projects_charity_name}</span>
                            </h5>
                            <h5>
                                <span>{'Metting venue'}:</span>{' '}
                                <span>{product.custom_projects_meeting_venue}</span>
                            </h5>
                            <h5>
                                <span>{'Date'}:</span>{' '}
                                <span>
                                    {dateFormatFunction(product.custom_projects_meeting_datetime)}
                                </span>
                            </h5>
                            <h5>
                                <span>{'Time'}:</span>{' '}
                                <span>
                                    {' '}
                                    {timeFormatFunction(
                                        product.custom_projects_meeting_datetime,
                                        'hh:mm A',
                                    )}
                                </span>
                            </h5>
                            <h5>
                                <span>{'Duration'}:</span>{' '}
                                <span>
                                    {' '}
                                    {hoursMinutesFormateFunction(
                                        product.custom_projects_meeting_duration,
                                    )}
                                </span>
                            </h5>
                        </div> */}

                        <div className="listActBtn">
                            {/* <div className="listBidInfo d-flex justify-content-between align-items-center">
                                <p className="d-flex justify-content-center align-items-center">
                                    <span>{currencyFormat(product.buynowamount)}</span>
                                    {props.from == 'cart' ? (
                                        <>
                                            <span className="listDivider">|</span>
                                            <span>Unpaid</span>
                                        </>
                                    ) : null}
                                </p>
                            </div> */}
                            {props.from == 'buynowcart' ? (
                                <>
                                    {/* {props.blockRemoveCart ? null : (
                                        <Button
                                            id="remove_from_cart"
                                            className="removeCart"
                                            onClick={() =>
                                                props.changeOnCart({
                                                    cart_id: product.cart_id,
                                                    qty: product.qty,
                                                    product_id: product.projects_id,
                                                })
                                            }
                                        >
                                            {'Remove from cart'}
                                        </Button>
                                    )} */}
                                    {/* <div className="updateCartQuantity">
                                        <Button
                                            disabled={formik.values.quantity <= 1}
                                            onClick={() => {
                                                formik.setFieldValue(
                                                    'quantity',
                                                    parseInt(formik.values.quantity) - 1,
                                                )
                                            }}
                                        >
                                            <span className="material-icons">remove_circle</span>
                                        </Button>
                                        {Object.values(mapData(formikQuantity))}
                                        <Button
                                            onClick={() => {
                                                formik.setFieldValue(
                                                    'quantity',
                                                    parseInt(formik.values.quantity) + 1,
                                                )
                                            }}
                                        >
                                            <span className="material-icons">add_circle</span>
                                        </Button>
                                    </div> */}
                                </>
                            ) : props.from == 'cart' ? (
                                <>
                                    {product.in_cart === 0 ? (
                                        <Button
                                            id="add_to_cart"
                                            className="removeCart"
                                            onClick={() =>
                                                props.changeOnCart({
                                                    cart: 1,
                                                    id: product.projects_id,
                                                })
                                            }
                                        >
                                            {'Add to cart'}
                                        </Button>
                                    ) : (
                                        <>
                                            {/* // <Button
                                        //     id="remove_from_cart"
                                        //     className="removeCart"
                                        //     onClick={() =>
                                        //         props.changeOnCart({
                                        //             cart: 0,
                                        //             id: product.projects_id,
                                        //         })
                                        //     }
                                        // >
                                        //     {'Remove from cart'}
                                        // </Button> */}
                                        </>
                                    )}
                                </>
                            ) : null}
                        </div>
                    </div>
                </>
            ) : null}
        </>
    )
}
export default CartItem
